import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'

export interface ITag extends IModelBase {
  name?: string
  slug?: string
  position: number
  children?: Array<ITag>
  parent?: ITag
  format_tag_key?: string
  format_tag_name?: string
}

export default class Tag extends ModelBase {
  name = ''
  slug = ''
  position = 0
  children: Array<Tag> = []
  sortedChildren: Array<Tag> = []
  parent?: Tag
  format_tag_key?: string
  format_tag_name?: string

  constructor(defaults?: ITag) {
    super(defaults)
    if (defaults) {
      this.name = defaults.name
      this.slug = defaults.slug
      this.position = defaults.position
      this.children = defaults.children?.map(c => new Tag(c)) || []
      this.format_tag_key = defaults.format_tag_key
      this.format_tag_name = defaults.format_tag_name
      this.sortedChildren = this.children.sort((a, b) => {
        if (a.position < b.position) return -1
        if (a.position > b.position) return 1
        if (a.slug < b.slug) return -1
        if (a.slug > b.slug) return 1
        return 0
      })
      this.parent = defaults.parent ? new Tag(defaults.parent) : undefined
    }
  }

  toParams(): KeyPair {
    return {}
  }
}
